import React, { useState, useEffect, useContext, createContext } from "react";  
import { useHistory, useLocation } from "react-router-dom"; 
import "./common/header/header.css"; 
import Config from './config.json'
import "./common/style.css";
import {faTags} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios"; 
import 'moment-timezone'; 
import "bootstrap/dist/js/bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import UserService from "./common/util/UserService";
import "bootstrap/js/src/dropdown";
import TaskService from "./common/util/TaskService";
import "./App.css"; 
import ModuleService from "./common/util/ModuleService"; 
import _ from "lodash"; 
import { useDispatch, useSelector } from "react-redux"; 
import queryString from "query-string";
import config from "./config.json"; 
import Loader from "./common/loader";
import { AllAccounts, AllAppUsers } from "./Context/AppActions";
import AppContext from "./Context/AppContext";
import { getSocket } from "./Socket";
import AwsServerService from "./common/util/AwsServerService";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'; 
import EmailReminder from "./components/EmailSection/EmailReminder";  
import { canAccess, customLinkFields, firstArr} from "./common/util/appUtils";
import FieldService from "./common/util/FieldService";
import EmailService from "./common/util/EmailService"; 
import { setAllDeals, setAllModule, setAllModuleUsers, setModuleContacts, setRefershModule } from "./Context/ReduxContext"; 
import { setAccessContext } from "../src/Context/UserContext"
import CatalystService from "./common/util/CatalystService";  
import NavbarManager from "./navbar/NavbarManager";
import ChatModelWrapper from "./layout/ChatModelWrapper";
import AppRoutes from "./AppRoutes"; 
import ReminderNotification from "./common/ReminderNotification";
import { evaluateEdgeVisibility } from "./Util/CommonUtil";
dayjs.extend(utc); 

export const AppDataRequired = createContext();

function App() {
  const [appDataContext, setAppDataContext] = useState({
    AllUsers:[],
    DealStatus:[],
    // AllDeals:[],
    DealFields:[],
    // AllTasks:[],
    CriteriaData:[],
    TaskFlows:[],
    filePickerPath:[],
  });
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const [cacheAllDeals,setCacheAllDeals]=useState([]);
  const AppData = useContext(AppContext);
  const { dispatch ,state} = AppData || {}; 
  const AllModuleUsers = useSelector((state) => state.AppReduxContext.AllModuleUsers);
  const reduxDispatch = useDispatch();  
  const [ModulesFromApi, setModulesFromApi] = useState([]); 
  const socket = getSocket(); 
  const backendUrl = config.backend_url;   
  const [token, setToken] = useState(null);  
  const [currentUser, setCurrentUser] = useState(null);
  const userInfo = JSON.parse(localStorage.getItem("userinfo")); 
  const [loader, setLoader] = useState(false); 
  const [tokenObj, setTokenObj] = useState(null);
  const [allUsers, setAllUsers] = useState([]);
  const moduleApiNameForSubform = ["WWP_Violations", "Previous_Solar_Info"];

  useEffect(() => {
    addAccessContext();
        try {
          // Fetch the MODULES data
          AwsServerService.CrudServiceHandler({
            method: "GET",
            data: "",
            route: "MODULES",
          }).then(res=>{ 
            // Map the response to the desired structure
            let arr = [{
              UserType_Name: "Internal",
              UserType_value: "Zoho Users"
            }];
            const ModulesData = res.data.map((item) => {
              let temp = {
                UserType_Name: item?.ModuleDisplayName,
                UserType_value: item?.ModuleApiName
              }
              arr.push(temp);
              return {
                ModuleDisplayName: item?.ModuleDisplayName,
                ModuleApiName: item?.ModuleApiName,
                ApiPrimaryField: item?.ApiPrimaryField,
                ApiNameField: item?.ApiNameField,
              }
            });
            reduxDispatch(setAllModule(arr));
            // Set the ModuleData state
            setModulesFromApi(ModulesData);
          })
        } catch (error) {
          console.error("Error fetching modules:", error);
        }
  }, []);
 
  const getContactsByModule =()=>{
    ModuleService.GetModuleList("Contacts").then(res=>{
      if(res.data){
        let obj = {};
        res.data.forEach(contact=>{
          if(obj[contact.Contact_Type]){
            obj[contact.Contact_Type].push(contact)
          }else{
            obj[contact.Contact_Type] = [contact]
          }
        })
        allUsers?.forEach(u=>{
          if(obj["Internal"]){
            obj["Internal"].push({
              id:u.zuid,
              Email:u.email,
              name:u.full_name,
            })
          }else{
            obj["Internal"] = [{
              id:u.zuid,
              Email:u.email,
              name:u.full_name,
            }]
          }
        })
        // modifyContactData(obj);
        reduxDispatch(setModuleContacts(obj));
      }
    }).catch(e=>{
      console.error(e);
    })
  }
  useEffect(e=>{
    if(allUsers && allUsers.length>0){
      getContactsByModule();
    }
  },[allUsers]);
  useEffect(e=>{
    if(ModulesFromApi && ModulesFromApi.length>0){
      AllModuleData()
    }
  },[ModulesFromApi])

  useEffect(()=>{
    if(state.AllAppUsers && state.AllAppUsers.length>0){
      checkUsers(state.AllAppUsers);
    }
   },[state.AllAppUsers])

  const AllModuleData = async () => {
    try {
      if (ModulesFromApi?.length > 0) {
        // const promises = ModulesFromApi.map((item) =>
        //   ModuleService.GetModuleList(item?.ModuleApiName)
        // );
        await Promise.all(ModulesFromApi.map((item) => ModuleService.GetModuleList(item?.ModuleApiName)))
        .then(results=>{ 
          const updatedOptions = { ...AllModuleUsers};
          results.forEach((res, index) => {
            if (res?.data) { 
              const moduleApiName = ModulesFromApi[index]?.ModuleApiName;
              const apiNameField = ModulesFromApi[index]?.ApiNameField;
              const apiPrimaryField = ModulesFromApi[index]?.ApiPrimaryField;
              const apiEmailField = ModulesFromApi[index]?.ApiEmailField; 
              updatedOptions[moduleApiName] = res.data.map((d) => ({
                label: d[apiNameField],
                value: d[apiPrimaryField],
                email: d[apiEmailField],
                icon: <FontAwesomeIcon icon={faTags} />,
              }));
            }
          }); 
          reduxDispatch(setAllModuleUsers(updatedOptions));
        })
      }
    } catch (error) {
      console.error("Error occurred during module API calls:", error);
    }
  };

  // const getTasksAndSubtasks = async (data,task) => {
  //   const result = []; 
  //   const taskMap = new Map();
  //   const subtaskMap = new Map(); 
  //   data?.forEach(pipeline => {
  //     pipeline.Tasks?.forEach(task => { 
  //       taskMap.set(task.TaskROWID, task);
  //       result.push({
  //         label: task.TaskName,
  //         value: `Tasks_${task.TaskROWID}`
  //       }); 
  //       if (task.SubTasks) {
  //         task.SubTasks?.forEach(subtask => {
  //           subtaskMap.set(subtask.SubTaskROWID,subtask)
  //           result.push({
  //             label: subtask.TaskName,
  //             value: `SubTasks_${subtask.SubTaskROWID}`
  //           });
  //         });
  //       }
  //     });
  //   }); 
  //   if(taskMap){
  //     await getCriteriaFieldsAndObjects(AllDeals,Array.from(taskMap).map(a=>a[1])).then(res=>{
  //       let contextState={...appDataContext,AllTasks:Array.from(taskMap).map(a=>a[1]),CriteriaData:res};
  //       // contextState["CriteriaData"]=res; 
  //       setAppDataContext(contextState); 
  //     }).catch(e=>{
  //       console.error(e);
  //     })
  //   }   
  //   return result; 
  // };

  useEffect(e=>{
    ModuleService.GetModuleList("Accounts")
    .then((result) => {
      if (result) {
        dispatch(AllAccounts(result.data))
      }
    })
    .catch((err) => {
      console.error(err);
    });
  }, [])

  // useEffect(e=>{
    // if(allPipeline && AllDeals){
      // getTasksAndSubtasks(allPipeline,"tasks")
    // }
  // },[allPipeline,AllDeals])
  
  useEffect(e=>{
    // let ob={...appDataContext,AllDeals:cacheAllDeals};
    // setAppDataContext(ob);
    let module = accessContext.modulePermissions?.find(e=>e.module_name == "Deals");
    let criteria= module?.selectFilter || [];
     
    const deals = cacheAllDeals.filter(deal => evaluateEdgeVisibility({ Project: deal }, { Criteria: criteria }, [], null))
    reduxDispatch(setAllDeals(deals));
  },[cacheAllDeals, accessContext.modulePermissions])
  
  useEffect(e=>{
    const backendUrl = Config.backend_aws_server_url+"catalyApi/getAllDealPages";
        var config = {
            'token': localStorage.getItem('token')
    };
    axios.post(backendUrl, {...config})
    .then((res)=> { 
      if(res.data.data){ 
        setCacheAllDeals(res.data.data);
      }
    }).catch(e=>{ 
    })
    //AwsServerService.getAllPipeline().then(res => { 
   //   if (res) {
   //     setAllPipeline(res)
   //   }
    //}) 
    ModuleService.GetModuleList("Accounts")
      .then((result) => {
        if (result) {
          dispatch(AllAccounts(result.data))
        }
      })
      .catch((err) => {
        console.error(err);
      });
      AwsServerService.getAllTaskFlows().then(res=>{
        const object = res?.reduce((acc, currentItem) => {
          acc[currentItem.ROWID] = currentItem;
          return acc;
        }, {});
        setAppDataContext({...appDataContext,TaskFlows:object})
      }).catch(err=>{
        console.error(err);
      })
  },[tokenObj])
  //Hrushikesh shelke new code ends 

  const [routesParams, setRoutesParams] = useState({});
  let history = useHistory();
  let location = useLocation();

  useEffect(()=>{
    location.state = {};
  },[routesParams]);
  
   useEffect(
    (e) => {
      if (history && history.replace) {
        if(accessContext?.modulePermissions?.length>0){
          let locationName = history?.location?.pathname?.includes("setting")?"/settings" : history?.location?.pathname?.includes("Email")?"/emails": history?.location?.pathname?.includes("Accounts")?"/clients":history?.location?.pathname?.includes("Documents")?"/documents":history?.location?.pathname?.includes("timeclock")?"/time clock":history?.location?.pathname?.toLowerCase();
          let currentModulePermission = accessContext.modulePermissions.find(m=>locationName?.includes(m.module_name?.toLowerCase()));
          if(currentModulePermission){
            let canView = canAccess(accessContext, currentModulePermission?.module_name, "View");
            if(!canView || canView === "None"){
              history.push({pathname:"/", state:{}})
              history.location = {hash: "",pathname: "/",search: "",state: {}}
            }
          }
        }
        var currentURL = window.location.href; 
        // Check if the previous entry in the history is the same as the current URL
        if (history.state && history.location.pathname === currentURL) {
          history.replace(null, "", currentURL);
        }
      }
    },
    [history.location, accessContext]
  );

   useEffect(e=>{ 
    socket.on("refresh_activity",(data)=>{
      reduxDispatch(setRefershModule({module:"task-activity",data:data}))
    }) 
    socket.on("refresh_task",(data)=>{
      reduxDispatch(setRefershModule({module:"View-Task",data:data}))
    })   
    socket.on("Refresh_Calendar",(data)=>{
      // pullNotifications();
      // reminderSchedular("Trigger From Server",data)
      if(data && data?.attendees?.find(a=>a.email==userInfo.email_id)){
        reduxDispatch(setRefershModule({module:"Calendar",data:data}))
      }
    })
    socket.on("Refresh_Module",(data)=>{
      if(data){
        reduxDispatch(setRefershModule({module:data}))
      }
    })
    socket.on("access-updated",(data)=>{
      addAccessContext();
    })
   },[]) 

  const addAccessContext = async ()=>{
    AwsServerService.GetUserProfile(userInfo?.email_id).then(res=>{
          reduxDispatch(
            setAccessContext({
              ...accessContext,
              modulePermissions: res.data[0]?.MODULE_PERMISSIONS,
              fieldPermissions: res.data[0]?.FIELD_PERMISSIONS,
              userPermission: res.data[0]?.USER_PERMISSIONS,
              roles: res.data[0]?.role_id,
              profile: {
                id: res.data[0]?.ROWID,
                name: res.data[0]?.PROFILE_NAME,
              },
            })
        );
        }).catch(err =>{
            console.error(err);
        })
  }
  useEffect(() => {
      if (userInfo?.email_id) { 
        EmailService.GetCurrentEmailAccount(userInfo?.email_id)
          .then((result) => { 
            if(result.data && result.data[0].accountId){
              AwsServerService.getUserByEmail(userInfo?.email_id).then(ress=>{
                if(!ress.data[0].accountId){
                  let inbox= result.data[0].Folders.find(e=>e.folderType=="Inbox").folderId;
                  let sent= result.data[0].Folders.find(e=>e.folderType=="Sent").folderId;
                  if(inbox && sent){
                    CatalystService.updateUserToken({UserEmail:userInfo.email_id,accountId:result.data[0].accountId,Inbox:inbox,Sent:sent})
                  }
                }
              })
            }
          })
          .catch((err) => { 
          })
      }
    }, [userInfo?.email_id])

  // reused function for file prev.
  // new code end
  //Nagesh Altekar code start//  
  const getUserThumbnailUrl = (zuid) => {
    const loginProfileUrl =
      "https://contacts.zoho.com/file?ID=" + zuid + "&fs=thumb";
    return loginProfileUrl;
  };

  let timeTokenInterval; 
 
  useEffect(() => {
    // addAccessContext()
    if (token) { 
      fetchAccounts();
      try {
        // handleAskNotification()
        var userManagement = window.catalyst.userManagement;
        var currentUserPromise = userManagement.getCurrentProjectUser();
        currentUserPromise
          .then((response) => {
            if (response.status !== "failure") {
              localStorage.setItem(
                "userinfo",
                JSON.stringify(response.content)
              );
              setCurrentUser(response.content);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (err) {
        setCurrentUser(null);
      }
    }
  }, [token]); 
  
  async function checkUsers(zohoUsers){
   AwsServerService.fetchLocalUsers().then(localUsers=>{
    const matchedUsers = []
    const unmatchedUsers = []
      zohoUsers.forEach(zoho => {
      const localMatch = localUsers?.data.find(
        local => String(local.zuid) === String(zoho.zuid)
      );
      if (localMatch) {
        matchedUsers.push(localMatch);
      } else {
        unmatchedUsers.push(zoho);
        unmatchedUsers.forEach(user => {
          const payLoad = {
            first_name: user?.first_name,
            last_name: user?.last_name,
            full_name: user?.first_name + " " + user?.last_name,
            country: user?.country,
            state: user?.state,
            EMAIL_ID: user?.email,
            email: user?.email,
            city: user?.city,
            zip: user?.zip,
            zoho_user_id: user?.id,
            zuid: user?.zuid,
            phone: user?.phone,
            status: user?.status,
            CREATEDBY: userInfo.email_id
          };
          AwsServerService.AddUser(payLoad);
        });
      }
    });
    reduxDispatch(
      setAccessContext({
        ...accessContext,
        user : matchedUsers,
      })
    )
  }).catch(e=>{
    console.error(e);
  })
  }

  async function fetchAccounts(){
    let contextState={...appDataContext};
      await UserService.GetAllUsers()
        .then((result) => {
          setAllUsers(result.data.users);
          contextState={...contextState,AllUsers:result.data.users};
          dispatch(AllAppUsers(result.data.users))
          let filterUser = result.data.users.filter(
            (one) => one.email == userInfo.email_id
          );
          if (filterUser.length > 0) {
            localStorage.setItem(
              "ProfilePhoto",
              getUserThumbnailUrl(filterUser[0].zuid)
            );
            localStorage.setItem("ZUID", filterUser[0].zuid);
            localStorage.setItem("TIMEZONE", filterUser[0].time_zone);
          } else {
            localStorage.removeItem("ProfilePhoto");
          }
        })
        .catch((err) => {
          console.error(err);
        });
      await TaskService.GetDealStatus()
      .then((res) => {
        contextState={...contextState,DealStatus:res};
      })
      .catch((err) => {
        console.error(err);
      });
      await FieldService.GetFields("all", "Deals")
      .then(async (result) => {
        let arr = [];
        firstArr.forEach((one) => {
          let fieldObj = result.filter((object) => object.api_name == one);
          if (fieldObj.length > 0) {
            fieldObj = fieldObj[0];
            fieldObj.field_label = fieldObj.field_label.replace("0", "");
            let obj = {};
            obj.field = fieldObj.api_name;
            obj.id = fieldObj.id;
            obj.isChecked = false;
            obj.isDragOver = false;
            obj.isSearch = true;
            fieldObj.field_label == "Owner's Street Name"
              ? (obj.name = "Owner's Street Address")
              : (obj.name = fieldObj.field_label);
            obj.type = fieldObj.data_type;
            arr.push(obj);
          }
        });
        result.forEach((one) => {
          if (!firstArr.includes(one.api_name)) {
            let obj = {};
            obj.field = one.api_name;
            obj.id = one.id;
            obj.isChecked = false;
            obj.isDragOver = false;
            obj.isSearch = true;
            obj.name = one.field_label.replace("0", "");
            obj.type = one.data_type == "formula" ? "number" : one.data_type;
            arr.push(obj);
          }
        });
        const notIncludesFileds = ["latitude", "longitude"];
        arr = arr.filter((one) => !notIncludesFileds.includes(one.name));
        moduleApiNameForSubform.forEach((one) => {
          let obj = {};
          obj.field = one;
          obj.id = one;
          obj.isChecked = false;
          obj.isDragOver = false;
          obj.isSearch = true;
          obj.name = one.replaceAll("_", " ");
          obj.type = "text";
          if (one == "Previous_Solar_Info") {
            arr.splice(38, 0, obj);
          }
        });
        arr = _.uniqBy(arr, "name");
        arr = [...arr, ...customLinkFields]
        contextState={...contextState,DealFields:arr};
      })
      .catch((err) => {
        console.error(err);
      });
      setAppDataContext(contextState);
  }
  
  useEffect(() => { 
    let user_token = localStorage.getItem("user_token");

    setTokenObj(user_token);
  }, []);

  useEffect(() => { 
    if (tokenObj) {
      getToken();
    } else {
      if (!localStorage.getItem("user_token")) {
        getAuthCodeURL();
      }
    }
  }, [tokenObj]);     
  async function getUserDetails() {
    var userManagement = window.catalyst.userManagement;
         try{
          const response = await userManagement.getCurrentProjectUser() 
            if (response.status !== "failure") {
              return response.content.email_id;
            } else {
              throw new Error("Failed to fetch user email");
            }
          } catch (err) {
            getUserDetails(); 
          }
  }
  const helperFnGetTokenFromCode = (code) => { 
    return new Promise((resolve, reject) => {
      axios
        .post(backendUrl + "token_code", {
          code: code,
          redirect_url: config.auth_prod_redirect_url
        })
        .then(async (result) => {
          if(result.data.error){
            return
          }
          localStorage.setItem("user_token", JSON.stringify(result.data));
          localStorage.setItem("refresh_token", result.data.RefreshToken);
          localStorage.setItem("token", "Bearer " + result.data.access_token);
          let email= await getUserDetails();
          let tokenIssuedAt = dayjs.utc(result.data.tokenTime); 
          let expirationTime = tokenIssuedAt.add(result.data.expires_in, 'second');
          let payload = {
            UserEmail:email,
            AccessToken:result.data.access_token,
            RefreshToken:result.data.refresh_token,
            ExpirationTime:expirationTime.format('YYYY-MM-DD HH:mm:ss'),
            TokenIssuedTime:tokenIssuedAt.format('YYYY-MM-DD HH:mm:ss'),
            ExpiresAt:result.data.expires_in
          }
          CatalystService.saveUserToken(payload).then(res=>{
            console.log("token added",res);
          }).catch(err=>console.log(err))
          setTokenObj(result.data);
          resolve(result.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  const getAuthCodeURL = () => {
    const parsedHash = queryString.parse(window.location.search);
    if (parsedHash && parsedHash.code) {
      helperFnGetTokenFromCode(parsedHash.code)
        .then((result) => {
          console.error(result);
        })
        .catch((err) => {
          console.error(err);
        });
    } else { 
      window.location.href = config.production_auth_url;
    }
  };

  const getToken = async () => { 
    let user_token = localStorage.getItem("user_token");
    let obj = JSON.parse(user_token);
    if (obj) {
      await axios
        .get(backendUrl + "token/" + obj.refresh_token)
        .then((result) => {
          setToken("Bearer " + result.data.access_token);
          localStorage.setItem("refresh_token", result.data.RefreshToken);
          localStorage.setItem("token", "Bearer " + result.data.access_token);
          let start = new Date(result.data.tokenTime);
          // setTokenTime(start);
          clearInterval(timeTokenInterval);
          if(localStorage.getItem("ProfilePhoto") === undefined || localStorage.getItem("ProfilePhoto") === null || localStorage.getItem("ProfilePhoto") == ""){
            // getToken();
            fetchAccounts();
          }
        })
        .catch((err) => { 
          // getToken();
          let rftoken = localStorage.getItem("refresh_token");
          if (rftoken) {
       axios
        .get(backendUrl + "token/" + rftoken)
        .then((result) => {
          setToken("Bearer " + result.data.access_token);
          localStorage.setItem("token", "Bearer " + result.data.access_token); 
          clearInterval(timeTokenInterval);
        });
       }
      })
    }
  };
   
  if (currentUser) {
    return (
        <AppDataRequired.Provider value={appDataContext}>
          <div className="container-box">
            <EmailReminder/> 
            {loader ? <Loader /> : <></>}
            <div>
              <NavbarManager currentUser={currentUser} history={history} setRoutesParams={setRoutesParams}/>
              <ChatModelWrapper history={history}/> 
            </div>
           <AppRoutes 
              getToken={getToken}
              allUsers={allUsers}
              ApproutesParams={routesParams}
              helperFnGetTokenFromCode={helperFnGetTokenFromCode}
              setLoader={setLoader}
           />
           <ReminderNotification token={token}/>
          </div>
        </AppDataRequired.Provider>
      // </Provider>
    );
  } else {
    //window.catalyst.auth.signIn("root");
  }
}

export default App;
